import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=384bf3fb&scoped=true&"
import script from "./Favorites.vue?vue&type=script&lang=ts&"
export * from "./Favorites.vue?vue&type=script&lang=ts&"
import style0 from "./Favorites.vue?vue&type=style&index=0&id=384bf3fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384bf3fb",
  null
  
)

export default component.exports